module.exports = __webpack_public_path__ + "media/images/samples/300x300/4-995a82be564e7a09a0f80e7ea1de2d6c.jpg";